import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { parentRoutes } from "../constants/constants";

export const checkIdType =
  /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
export const setStepStatus = (dob, values) => {
  const completeFill = Object.values(values).every(
    (elem) => elem !== "" && elem !== null
  );
  const partialFill = Object.values(values).some(
    (elem) => elem !== "" && elem !== null
  );

  return completeFill && dob ? 2 : partialFill ? 1 : 0;
};

export const overAllStatus = (array) => {
  return array.every((elem) => elem === 2);
};

export const FormHeading = styled(Typography)`
  &.MuiTypography-h4 {
    font-size: 28px !important;
    font-weight: 600;
  }
`;

export const casesLinks = (data) => [
  {
    id: 1,
    name: "List of cases",
    to: "cases-list",
    route: "/cases/cases-list",
    list: data?.filter((item) => !item.isDeleted),
  },
  {
    id: 2,
    name: "Marked cases",
    to: "marked-cases",
    route: "/cases/marked-cases",
    list: data?.filter((item) => item?.isMarked) || [],
  },
  {
    id: 3,
    name: "Updated Cases",
    to: "updated-cases",
    route: "/cases/updated-cases",
    list:
      data?.filter(
        (item) =>
          new Date(item.updatedDateByClient).getTime() >
          new Date(item?.lastViewed).getTime()
      ) || [],
  },
  {
    id: 4,
    name: "Deleted Cases",
    to: "deleted-cases",
    route: "/cases/deleted-cases",
    list: data?.filter((item) => item?.isDeleted) || [],
  },
];

export const checkInDepthRoutes = (obj, item) => {
  if (obj.menuStructureId === item.parentId) {
    if (obj.hasOwnProperty("children")) {
      obj.children.push({ ...item, route: item.route.substr(1) });
    } else {
      obj["children"] = [{ ...item, route: item.route.substr(1) }];
    }
  } else {
    if (obj?.hasOwnProperty("children")) {
      obj.children.forEach((child) => {
        checkInDepthRoutes(child, item);
      });
    }
  }
};

export const getUserIdFromLocalStorage = () => {
  let id = localStorage.getItem("loggedInUserId");

  return id;
};

export const getClientIdFromLocalStorage = () => {
  let id = localStorage.getItem("clientId");

  return id;
};

let ftGraphCheck = false;

export const getFTGraphCheck = () => {
  return ftGraphCheck;
};

export const setFTGraphCheck = (check) => {
  ftGraphCheck = check;
};
export const getTimeFromDateStamp = (timestamp) =>
  new Date(`${timestamp}Z`).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

export const getDateFromDateStamp = (timestamp) => {
  const date = new Date(`${timestamp}Z`);
  let month = date.getMonth() + 1;
  return date.getFullYear() + "/" + month + "/" + date.getDate();
};
export const getDayFromDateStamp = (timestamp) => {
  const date = new Date(timestamp);
  return date.getDate();
};
export const getMonthFromDateStamp = (timestamp) => {
  const date = new Date(timestamp);
  return date.getMonth();
};
export const getYearFromDateStamp = (timestamp) => {
  const date = new Date(timestamp);
  return date.getFullYear();
};

export const getCurrentCompleteDate = () => {
  const date = new Date();
  return date.getFullYear() + "/" + date.getMonth() + "/" + date.getDate();
};
export const matchRoutesFromMenuStructure = (name = "assets") => {
  return localStorage.getItem("menuStructure")
    ? JSON.parse(localStorage.getItem("menuStructure"))?.filter(
        (item) => item?.route === parentRoutes[name]
      )[0]?.children
    : [];
};
export const getObjKeyByValue = (obj = {}, value = "") => {
  return Object.keys(obj).find(
    (key) => obj[key].toLowerCase() === value.toLowerCase()
  );
};
export const getKeyFromText = (name) =>
  name
    ?.toLowerCase()
    ?.replaceAll(" ", "-")
    ?.replaceAll("/", "-")
    ?.replaceAll(",", "")
    ?.replaceAll("'", "");

export const getAppIntroduction = (t) => [
  {
    heading: t("intro", {
      returnObjects: true,
    }).heading,
    description: t("intro", {
      returnObjects: true,
    }).description,
    image: t("intro", {
      returnObjects: true,
    }).image,
    rederFirstElement: false,
  },
];

export const getDiscoverMore = (t) => [
  // {
  //   title: t("card-1", {
  //     returnObjects: true,
  //   }).title,
  //   image: t("card-1", {
  //     returnObjects: true,
  //   }).image,
  //   description: t("card-1", {
  //     returnObjects: true,
  //   }).description,
  //   isHighlighted: true,
  //   rederFirstElement: false,
  // },

  // {
  //   title: t("card-2", {
  //     returnObjects: true,
  //   }).title,
  //   image: t("card-2", {
  //     returnObjects: true,
  //   }).image,
  //   description: t("card-2", {
  //     returnObjects: true,
  //   }).description,
  //   isHighlighted: false,
  //   rederFirstElement: false,
  // },

  // {
  //   title: t("card-3", {
  //     returnObjects: true,
  //   }).title,
  //   image: t("card-3", {
  //     returnObjects: true,
  //   }).image,
  //   description: t("card-3", {
  //     returnObjects: true,
  //   }).description,
  //   isHighlighted: false,
  //   rederFirstElement: false,
  // },

  // {
  //   title: t("card-4", {
  //     returnObjects: true,
  //   }).title,
  //   image: t("card-4", {
  //     returnObjects: true,
  //   }).image,
  //   description: t("card-4", {
  //     returnObjects: true,
  //   }).description,
  //   isHighlighted: false,
  //   rederFirstElement: false,
  // },

  // {
  //   title: t("card-5", {
  //     returnObjects: true,
  //   }).title,
  //   image: t("card-5", {
  //     returnObjects: true,
  //   }).image,
  //   description: t("card-5", {
  //     returnObjects: true,
  //   }).description,
  //   isHighlighted: false,
  //   rederFirstElement: false,
  // },
  {
    title: t("card-6", {
      returnObjects: true,
    }).title,
    image: t("card-6", {
      returnObjects: true,
    }).image,
    isHighlighted: true,
    rederFirstElement: false,
  },
  {
    title: t("card-7", {
      returnObjects: true,
    }).title,
    image: t("card-7", {
      returnObjects: true,
    }).image,
    isHighlighted: false,
    rederFirstElement: false,
  },
  {
    title: t("card-8", {
      returnObjects: true,
    }).title,
    image: t("card-8", {
      returnObjects: true,
    }).image,
    isHighlighted: false,
    rederFirstElement: false,
  },
];
// export const navigateToFirstPage = (navigate) => {
//   localStorage.getItem("menuStructure") &&
//   JSON.parse(localStorage.getItem("menuStructure"))?.length > 0
//     ? navigate(JSON.parse(localStorage.getItem("menuStructure"))[0].route)
//     : navigate("/login");
//   // window.scrollTo({
//   //   top: 0,
//   //   left: 0,
//   //   behavior: "smooth",
//   // });
// };
export const navigateToFirstPage = (navigate) => {
  const phoneNumberConfirmed = localStorage.getItem("phoneNumberConfirmed");
  const isAuthenticated = localStorage.getItem("auth");

  return isAuthenticated === "true"
    ? phoneNumberConfirmed === "true" && navigate === "/login"
      ? navigate(JSON.parse(localStorage.getItem("menuStructure"))[0].route)
      : localStorage.getItem("menuStructure") &&
        JSON.parse(localStorage.getItem("menuStructure"))?.length > 0
      ? navigate(JSON.parse(localStorage.getItem("menuStructure"))[0].route)
      : navigate("/profile")
    : navigate("/login");
};

export const formatTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
};
export const changeUpdateFormat = (dateTime, language) => {
  const now = new Date(`${dateTime}Z`);
  const day = now.getDate();
  const month = now.getMonth() + 1; // Months are zero-indexed
  const year = now.getFullYear();
  const hours = now.getHours();
  const minutes = now.getMinutes().toString().padStart(2, "0");

  if (language == "en") {
    return `on ${day}/${month}/${year} at ${hours}:${minutes}`;
  } else {
    return `am ${day}.${month}.${year} um ${hours}:${minutes} Uhr`;
  }
};
